import { SavedBlockPoIsQuery } from '@/__generated__/graphql';
import { AnalysisCuboid, AnalysisCustomBlockWithFiles, CustomBlockQueryFilters } from '@/types';
import { StateMap } from '@/utils/stateMap';
import { atom } from 'jotai';

export const customBlockCuboids = atom<StateMap<string, AnalysisCuboid>>(
  new StateMap<string, AnalysisCuboid>()
);

export const selectedCustomBlock = atom<AnalysisCustomBlockWithFiles | undefined>(undefined);

export const hoveredCustomBlockId = atom<string | undefined>(undefined);

export const customBlocksQueryInput = atom<{
  hasMoreItems: boolean;
  page: number;
  sortBy: string | undefined;
  sortDir: number | undefined;
}>({
  hasMoreItems: true,
  page: 2,
  sortBy: undefined,
  sortDir: undefined,
});

export const selectedSavedBlockId = atom<string | undefined>(undefined);
export const allSavedBlocks = atom<SavedBlockPoIsQuery['pointOfInterests'] | undefined>();
export const selectedSavedBlock = atom<SavedBlockPoIsQuery['pointOfInterests'][0] | undefined>(
  (get) => get(allSavedBlocks)?.find((block) => block.id === get(selectedSavedBlockId))
);

export const customBlockQueryFilters = atom<CustomBlockQueryFilters>({
  excludeAlreadyPlannedBlocks: true,
});
